import { render, staticRenderFns } from "./TrendAnalysis.vue?vue&type=template&id=de9fd42c&scoped=true"
import script from "./TrendAnalysis.vue?vue&type=script&lang=js"
export * from "./TrendAnalysis.vue?vue&type=script&lang=js"
import style0 from "./TrendAnalysis.vue?vue&type=style&index=0&id=de9fd42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9fd42c",
  null
  
)

export default component.exports